import { PaginatedAPI, QueriesAPIModel } from 'src/app/models/api.model'
import { QueriesDashboardModel } from 'src/app/models/model'

export interface QueryState {
  summary: PaginatedAPI<QueriesAPIModel>
  dashboard: QueriesDashboardModel
  details: QueriesAPIModel
}

export const initialQueriesashboardState: QueryState = {
  dashboard: undefined,
  details: undefined,
  summary: undefined
}
